<template>
  <div class="form-elements">
    <div class="row flex md12">
      <form>
        <va-card :title="title">
          <slot></slot>

          <div class="row flex pull-right md12 xs12">
            <va-button @click.prevent="returnToParent" color="danger">Back</va-button>
            <va-button v-if="canEdit" @click.prevent="expirationModal = true" color="warning">Close</va-button>
            <va-button v-if="canEdit" @click.prevent="editModal = true" color="success">Edit</va-button>
          </div>
        </va-card>
      </form>
    </div>

    <!-- Close Modal Start -->
    <!-- Emits "expDateSet" event upon clicking close button -->
    <va-modal
      v-model="expirationModal"
      size="small"
      hideDefaultActions
      noOutsideDismiss
      title="Set Expiration Date"
      label="Expiration Date"
    >
      <va-date-picker
        label="Expiration Date"
        :config="{dateFormat:'d/m/Y'}"
        v-model="expirationDate"
      />
      <va-button
        style="margin-left: 17%"
        color="warning"
        @click="closeExpirationModal"
      >Close</va-button>
    </va-modal>
    <!-- Close Modal End -->

    <!-- Edit Modal Start -->
    <va-modal
      class="flex lg12 xs12 md12"
      v-model="editModal"
      :size="cModalSize"
      :title="editModalTitle"
      :label="editModalLabel"
      hideDefaultActions
      noOutsideDismiss
    >
      <!-- OnSubmit methods are not defined in this scope since the logic will most likely be complex -->
      <div class="form-elements">
        <div class="row flex md12">
          <form>
            <slot name="editSlot"></slot>
          </form>
        </div>
      </div>
      <template v-slot:actions>
        <va-button @click.prevent="editModal=false" color="danger">Back</va-button>
        <va-button v-if="canEdit" @click.prevent="editEvent" color="success">Edit</va-button>
        <slot name="extraButtons"></slot>
      </template>
    </va-modal>
    <!-- Edit Modal End -->
  </div>
</template>

<script>
import { editMixins } from "../consentMixins/editMixins.js";
export default {
  mixins: [editMixins],
  props: ["title", "editModalTitle", "editModalLabel", "modalSize"],
  data() {
    return {
      expirationModal: false,
      expirationDate: "",
      editModal: false
    };
  },
  computed: {
    canEdit() {
      return this.$store.getters.clearance;
    },
    cModalSize() {
      return this.modalSize;
    }
  },
  methods: {
    closeExpirationModal() {
      this.$emit("expDateSet", this.expirationDate);
      this.expirationModal = false;
    },

    returnToParent(){
      this.$emit("backEmit");
    },
  
    editEvent() {
      this.$emit("editSubmited");
      this.editModal = false;
    }
  }
};
</script>